import { Link } from "react-router-dom";
import { stats } from "@/mocks/news";

export default function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20stage%20with%20deep%20crimson%20spotlights%20cutting%20through%20warm%20amber%20haze%20and%20hints%20of%20green%20rim%20light%2C%20cinematic%20editorial%20background%2C%20high%20contrast%20dark%20moody%20atmosphere%2C%20no%20people%2C%20refined%20magazine%20cover%20aesthetic%20with%20subtle%20film%20grain%20and%20elegant%20negative%20space&width=1800&height=1000&seq=guwa-hero-01&orientation=landscape"
        alt="看瓜爆料今日速递氛围背景图"
        title="看瓜爆料今日速递 - 实时更新热点瓜料"
        className="absolute inset-0 h-full w-full object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/90"></div>

      <div className="relative mx-auto w-full max-w-site px-4 py-16 md:px-6 md:py-24">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-foreground-950/40 px-3 py-1.5 text-xs font-medium text-accent-300">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-400"></span>
            实时更新 · 今日速递持续进行中
          </span>

          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
            看瓜爆料 · 今日速递
            <span className="mt-2 block text-xl font-bold text-accent-300 md:text-3xl">
              新鲜瓜料随时刷，热点进展不错过
            </span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            看瓜爆料最新实时更新，把今日热点瓜料、新鲜爆料速递集中呈现。点开即看当下最热事件的进展，
            随时刷新随时有料，满足你第一时间追瓜、吃瓜、看内幕的需求。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/#today-feed"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-flashlight-line text-base" aria-hidden="true"></i>
              查看今日速递
            </Link>
            <Link
              to="/#hot-topic"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/30 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:border-accent-400 hover:text-accent-300"
            >
              <i className="ri-fire-line text-base" aria-hidden="true"></i>
              进入实时热榜
            </Link>
          </div>
        </div>

        <dl className="mt-14 grid grid-cols-2 gap-4 border-t border-background-100/15 pt-8 md:grid-cols-4 md:gap-6">
          {stats.map((item) => (
            <div key={item.label}>
              <dt className="text-xs text-background-300/80">{item.label}</dt>
              <dd className="mt-1.5 font-heading text-2xl font-black text-background-50 md:text-3xl">
                {item.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}